<div *ngIf="reportType === 'InDetail-Officer'">


    <div class="report-container" id="print-section">
        <div class="report-header" style="margin-bottom: 20px;margin-left: 10px;margin-right: 10px;">
            <!-- Top row: company name (left), report title (center) -->
            <div style="display: flex; justify-content: space-between; align-items: center;border-bottom: 1px solid black;
">
                <h1 class="company-name" style="margin: 0; flex: 1; text-align: left;border-bottom: 1px solid black">Vivek Saptahik</h1>
                <h2 class="report-title" style="margin: 0; flex: 2; text-align: center;font-size: 26px;border-bottom: 1px solid black">Book Payment Receipt
                    Ledger</h2>
                <div style="flex: 1;"></div> <!-- Filler for spacing symmetry -->
            </div>

            <!-- Second row: report type (left) and date (right) -->
            <div class="report-meta" style="display: flex; justify-content: space-between; margin-top: 10px;">
                <span class="report-type" style="text-align: left;">Office Rep InDetails</span>
                <span class="date-range" style="text-align: right;">
                    Date: {{ startDate | date: 'dd-MM-yyyy' }} to {{ endDate | date: 'dd-MM-yyyy' }}
                </span>
            </div>
        </div>


        <div class="table-responsive">
            <table class="styled-table table-bordered">
                <thead>
                    <tr>
                        <th>Receipt No</th>
                        <th>Receipt Date</th>
                        <th>Book Seller Name</th>
                        <th>Representative Name</th>
                        <th>Office Representative Name</th>
                        <th>Invoice Number</th>
                        <th>Invoice Date</th>
                        <th>Invoice Net Amount</th>
                        <th>Received Amount</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let data of PaymentBookOffInDFormBenas; let i = index">
                        <tr class="office-header">
                            <td colspan="1"><strong>Office Representative</strong></td>
                            <td colspan="8"><strong>{{data.office_rep_name}}</strong></td>
                        </tr>

                        <ng-container *ngFor="let repData of data.rep_data; let j = index">
                            <tr class="rep-header">
                                <td colspan="8"><strong>{{repData.rep_name}}</strong></td>
                                <td colspan="1" style="text-align: end;"><strong>{{repData.rep_total}}</strong></td>

                            </tr>

                            <tr class="data-row" *ngFor="let bookData of repData.book_data; let k = index">
                                <td>{{bookData.receipt_no}}</td>
                                <td>{{bookData.receipt_date}}</td>
                                <td>{{bookData.book_seller_name}}</td>
                                <td>{{bookData.rep_name}}</td>
                                <td>{{data.office_rep_name}}</td>
                                <td>{{bookData.bill_no}}</td>
                                <td>{{bookData.billdate}}</td>
                                <td class="amount-cell" style="text-align: end;">{{bookData.bill_amount}}</td>
                                <td class="amount-cell" style="text-align: end;">{{bookData.select_entry_amt}}</td>
                            </tr>

                            <tr class="rep-total">
                                <td colspan="8  "><strong>Rep Total:</strong></td>
                                <td colspan="1" style="text-align: end;"><strong>{{repData.rep_total}}</strong></td>
                            </tr>
                        </ng-container>

                        <tr class="office-total">
                            <td colspan="8"><strong>Office Rep Total:</strong></td>
                            <td colspan="1" style="text-align: end;"><strong>{{data.total}}</strong></td>
                        </tr>
                    </ng-container>
                </tbody>
                <tfoot>
                    <tr>
                        <td colspan="8"><strong>Grand Total:</strong></td>
                        <td colspan="1" style="text-align: end;"><strong>{{PaymentbookOffInDTotal2 | number:'1.2-2'
                                }}</strong></td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>

    <div class="button-container noPrint">
        <button class="modern-btn btn-primary-modern noPrint" (click)="exportExcel('Book_InDetail_Officewise')"
            mat-raised-button color="primary">
            📊 Export
        </button>

        <button class="modern-btn btn-primary-modern noPrint" mat-raised-button color="primary" (click)="printPage4()">
            🖨️ Print
        </button>

        <button class="modern-btn btn-secondary-modern noPrint" mat-button mat-dialog-close>
            ❌ Close
        </button>
    </div>
</div>